export const CALL_STATUS = [
    { code: 0, label: 'Đang đợi' },
    { code: 1, label: 'Đồng ý' },
    { code: 2, label: 'Không đồng ý mua' },
    { code: 3, label: 'Không nghe máy' },
    { code: 4, label: 'Không liên lạc được' },
    { code: 5, label: 'Bỏ qua' },
    { code: 6, label: 'Khóa' }];

// Waitting = 0,
// Accepted = 1,
// Rejected = 2,
// MissCall = 3,
// WrongPhoneNumber = 4,
// Ignore = 5,
// Locked = 6,